import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getZoneById({ commit, state }, { id }) {
    try {
      let zone = state.zones?.find((p) => p.id === id);
      if (!zone) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/zones/${id}`,
          method: "GET",
        });
        zone = response.data.data;
      }
      commit(MutationsType.SET_ZONE, zone);
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllZones({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/zones",
        method: "GET",
      });
      commit(MutationsType.SET_ZONES, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async getAllZonesByStoreId({}, { storeId }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/zones",
        method: "GET",
        params: {
          store_id: storeId,
        },
      });
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveZone({ commit }, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/zones",
        method: "POST",
        data: data,
      });
      commit(MutationsType.ADD_ZONE, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateZone({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/zones/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ZONE, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deleteZone({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/zones/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_ZONE, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetZone({ commit }) {
    commit(MutationsType.SET_ZONE, null);
  },
  resetModuleZones({ commit }) {
    commit(MutationsType.SET_ZONE, null);
    commit(MutationsType.SET_ZONES, null);
  },
};
